import sha256 from "hash.js/lib/hash/sha/256";
export default function criptografiaSHA256(string, salt) {
  return sha256()
    .update(string + salt)
    .digest("hex");
}

//SOURCE: https://geraintluff.github.io/sha256/
